(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["waitlist-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var TARGET = window.__seyaWaitlistUrl || '/pages/waitlist';

    function isTrigger(el) {
      var t = el.closest && el.closest('a, button');
      if (!t) return null;
      // Never hijack a real submit button — including the form on the waitlist page itself.
      if (t.type === 'submit' && t.closest('form')) return null;
      if (t.hasAttribute('data-waitlist')) return t;
      var href = t.getAttribute('href') || '';
      if (href.indexOf('#waitlist') !== -1) return t;
      var txt = (t.textContent || '').trim().toLowerCase();
      if ((t.tagName === 'A' || t.tagName === 'BUTTON') && txt === 'join the waitlist') return t;
      return null;
    }

    // Event delegation — survives theme-editor re-renders and late-rendered sections.
    document.addEventListener('click', function (e) {
      var t = isTrigger(e.target);
      if (!t) return;
      // Already on the waitlist page? Let the in-page anchor do its job.
      if (window.location.pathname.indexOf('/pages/waitlist') === 0) return;
      e.preventDefault();
      window.location.href = TARGET;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
